import React from 'react';
import { Box as MuiBox } from '@material-ui/core';
import PropTypes from 'prop-types';

export const Box = ({ children, ...forwardProps }) => <MuiBox {...forwardProps}>{children}</MuiBox>;

Box.propTypes = {
    children: PropTypes.node.isRequired,
};
